module.exports = __webpack_public_path__ + "static/media/news-5.5d034905.webp";